import React, { useEffect, useRef, useState } from "react";
import {
  Row,  
  Card,
  CardBody,  
} from "reactstrap";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";

import useToast from "src/components/Common/toast";
import "../../../assets/scss/custom/components/timeline.scss";

//import images
import { useDispatch } from "react-redux";
import { AppDispatch } from "src";
import FileUploadModal from "./FileUploadModal";
import { deleteAttachment, getAttachments, getProjectById } from "src/slices/Projects/thunk";
import { useGetProjectByIdQuery } from "src/services/khozi";

  

const Attachments = ({ project }: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [attachments, setAttachments] = useState(project.documentos);
  const { show, ToastComponent } = useToast();
  const [activeTab1, setactiveTab1] = useState<string>("1");
  
  const [newStatus, setNewStatus] = useState<string>("");
  const dispatch = useDispatch<AppDispatch>();

  const updateAttachmentList = () => {
    dispatch(getAttachments(project.id)).then(response =>{
      setAttachments(response.payload);
    });
  }

  const handleDelete = (id: number) => {
    setIsLoading(true);
    dispatch(deleteAttachment(id)).then(response => {
      if (typeof response.payload === "undefined") {
        show("Erro", "Erro ao apagar anexo.");        
      } else {
        show("Sucesso", "Anexo apagado com sucesso.");
        updateAttachmentList();   
      }      
      setIsLoading(false);
    });
  };  

  useEffect(() => {
    if (isLoading) {
      document.body.style.cursor = 'wait';
    } else {
      document.body.style.cursor = 'default';
    }

    return () => {
      document.body.style.cursor = 'default';
    };
  }, [isLoading]); 


  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <Row>
            <div className="col">
              <h5 className="card-title mb-2">Anexos</h5>
            </div>            
            <div className="col-auto d-flex flex-wrap align-items-start justify-content-md-end gap-2 mb-3">                  
              <FileUploadModal project={project} onCloseCallBack={updateAttachmentList}/>          
            </div>            
          </Row>          
          <div>
            <SimpleBar style={{ maxHeight: "280px" }}>
              <div className="list-group list-group-flush">
                {attachments.map((f: any, i: number) => {
                  return (
                    <div className="list-group-item py-3" key={i + "-file"}>
                      <div className="d-flex align-items-start">
                        <div className="flex-shrink-0 avatar-sm me-3">
                          <span className="avatar-title bg-light text-primary rounded font-size-20">
                            <i className="uil uil-paperclip"></i>
                          </span>
                        </div>
                        <div className="flex-grow-1 overflow-hidden">
                          <h5 className="font-size-13 mb-1 text-truncate">
                            <Link target="_blank" to={`${f.presigned_url}`} className="text-dark">{f.nome}</Link>
                          </h5>
                          {/*<p className="text-muted mb-0 font-size-12">1.2 MB</p>*/}
                        </div>
                        <div className="flex-shrink-0 ms-2">
                          <ul className="list-inline mb-0">
                            <li className="list-inline-item">
                              <Link to={`${f.presigned_url}`} className="text-muted font-size-18 px-2">
                                <i className="uil uil-download-alt"></i>
                              </Link>
                            </li>{" "}
                            <li className="list-inline-item">
                              <div  id={"delete-file-" + i} onClick={() => handleDelete(f.id)} className="text-muted font-size-18 px-2" style={{cursor: 'pointer'}}>
                                <i className={`${isLoading ? 'uil uil-hourglass' : 'uil uil-trash-alt'}`} ></i>
                              </div>
                            </li>                            
                          </ul>
                        </div>
                      </div>
                    </div>
                  );
                })}                
              </div>
            </SimpleBar>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default Attachments;
